let locales = {
  dashboardList_team_announcementCode: "Cod. / Autorizzati",
};

export default locales;
